module.exports = __webpack_public_path__ + "img/loginRight.d926d986.png";